import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NegativePipe } from './negative.pipe';

@NgModule({
  declarations: [NegativePipe],
  imports: [CommonModule],
  exports: [NegativePipe]
})
export class NegativePipeModule {}
